import { BrowserRouter } from "react-router-dom";
import Home from "./views/index"

function App() {
  return (
    <BrowserRouter>
      <Home />
    </BrowserRouter>
  );
}

export default App;
